import { Monitor, Moon, Sun } from "lucide-react";
import { useI18n } from "@/i18n";
import { useTheme, type ThemePref } from "@/lib/theme";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

export function ThemeToggle() {
  const { t } = useI18n();
  const { theme, setTheme } = useTheme();
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : Monitor;
  const options: { value: ThemePref; label: string; icon: typeof Sun }[] = [
    { value: "light", label: t("common.themeLight"), icon: Sun },
    { value: "dark", label: t("common.themeDark"), icon: Moon },
    { value: "system", label: t("common.themeSystem"), icon: Monitor },
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label={t("common.theme")}>
          <Icon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((o) => (
          <DropdownMenuItem key={o.value} onSelect={() => setTheme(o.value)} className={theme === o.value ? "font-semibold" : undefined}>
            <o.icon />
            {o.label}
            {theme === o.value && <span className="ml-auto size-1.5 rounded-full bg-primary" aria-hidden />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
